import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";
import {ProductPropertyType} from "@core/domain/substance";

function disableUnselectableCategories(node) {
    //  think through how to disable node
    node.isDisabled = !node.selectable;

    if (node.children) {
        node.children.forEach(disableUnselectableCategories);
    }
}

export default {
    lists() {
        return Cache.item('SubstanceLists', () => {
            return axios.get(ApiRouteProvider.substances.lists());
        }).getPromise();
    },

    listSubstances(listId) {
        return Cache.item('SubstanceListSubstances' + listId, () => {
            return axios.get(ApiRouteProvider.substances.listSubstances(listId));
        }).getPromise();
    },

    listSubstancesInclusion(listId, substanceIds) {
        return axios.post(ApiRouteProvider.substances.listSubstancesInclusion(listId), {
            substanceIds,
        });
    },

    materialCategories() {
        return Cache.item('SubstanceMaterialCategories', () => {
            return axios.get(ApiRouteProvider.substances.materialCategories());
        }).getPromise();
    },

    search(qs, context = {}) {
        return axios.get(ApiRouteProvider.substances.search(qs, context));
    },

    summary(ids = []) {
        const normalizedIds = Array.from(new Set(
            ids
                .map(id => Number(id))
                .filter(id => Number.isFinite(id) && id > 0)
        ));

        if (!normalizedIds.length) {
            return Promise.resolve({
                data: {
                    items: [],
                    missingIds: [],
                },
            });
        }

        return axios.get(ApiRouteProvider.substances.summary(normalizedIds));
    },

    resolveRegulations(substanceIds = []) {
        const normalizedIds = Array.from(new Set(
            substanceIds
                .map(id => Number(id))
                .filter(id => Number.isInteger(id) && id > 0)
        ));

        return axios.post(ApiRouteProvider.substances.regulationsResolution(), {
            substanceIds: normalizedIds,
        });
    },

    getCard(id) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/substance/card/' + id);
    },

    saveCard(id, card) {
        return axios.put(ApiRouteProvider.getBaseUrl() + '/substance/card/' + id, card);
    },

    addUserSubstance(substance) {
        return axios.post(ApiRouteProvider.getBaseUrl() + '/substance/user-substance', {
            substance,
        });
    },

    linkSubstance(listId, substanceId, parentId) {
        return axios.post(ApiRouteProvider.getBaseUrl() + '/substance/list/' + listId + '/substances/link', {
            substance: substanceId,
            parent: parentId,
        })
    },

    getProductPropertyData() {
        return Cache.item('SubstanceProductProperty', () => {
            return axios
                .get(ApiRouteProvider.getBaseUrl() + '/substance/product-property')
                .then(r => {
                    const disableUnselectableItemProperties = [
                        ProductPropertyType.MATERIAL_CATEGORY,
                        ProductPropertyType.MIXTURE_CATEGORY,
                    ];
                    disableUnselectableItemProperties.forEach((property) => {
                        if (r.data.properties.hasOwnProperty(property)) {
                            r.data.properties[property].data.forEach(disableUnselectableCategories);
                        }
                    });
                    return r;
                });
        }).getPromise();
    },

    getSubstanceLists(substanceId) {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/substance/' + substanceId + '/lists');
    }
};
